import { extendTailwindMerge } from 'tailwind-merge';

const cm = extendTailwindMerge({
  prefix: 'tw',
});

export default cm;
